// extracted by mini-css-extract-plugin
export default {"screen-titles--title":"Alert_screen-titles--title__xIUno","alert":"Alert_alert__1X9nI","alert-inline":"Alert_alert-inline__Y-2O-"};